import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  reports: {
    id: 'app.RehireCheckStage.ReportRequests.reports',
    defaultMessage: 'Reports',
    description: 'Workday requests configured for this stage',
  },
  limit: {
    id: 'app.RehireCheckStage.ReportRequests.limit',
    defaultMessage: 'Up to 3',
    description: 'Maximum number of configured reports',
  },
  allReports: {
    id: 'app.RehireCheckStage.ReportRequests.allReports',
    defaultMessage: 'Every report runs; we decide when all finish',
    description: 'All configured sources must settle before a decision',
  },
  add: {
    id: 'app.RehireCheckStage.ReportRequests.add',
    defaultMessage: 'Add report',
    description: 'Add a stage-owned report request',
  },
  newReport: {
    id: 'app.RehireCheckStage.ReportRequests.newReport',
    defaultMessage: 'New report',
    description: 'Display name for a report that has not been named',
  },
  path: {
    id: 'app.RehireCheckStage.ReportRequests.path',
    defaultMessage: 'Report path',
    description: 'Relative Workday custom report path',
  },
  edit: {
    id: 'app.RehireCheckStage.ReportRequests.edit',
    defaultMessage: 'Edit {report}',
    description: 'Accessible action name for editing the named report',
  },
  actions: {
    id: 'app.RehireCheckStage.ReportRequests.actions',
    defaultMessage: 'More actions for {report}',
    description:
      'Accessible action name for ordering or removing the named report',
  },
  up: {
    id: 'app.RehireCheckStage.ReportRequests.up',
    defaultMessage: 'Move up',
    description: 'Move the report earlier in the list',
  },
  down: {
    id: 'app.RehireCheckStage.ReportRequests.down',
    defaultMessage: 'Move down',
    description: 'Move the report later in the list',
  },
  run: {
    id: 'app.RehireCheckStage.ReportRequests.run',
    defaultMessage: 'Run report',
    description: 'Discover report columns using the current test inputs',
  },
  needed: {
    id: 'app.RehireCheckStage.ReportRequests.needed',
    defaultMessage: 'Run needed',
    description: 'No current successful report discovery exists',
  },
  ready: {
    id: 'app.RehireCheckStage.ReportRequests.ready',
    defaultMessage: 'Ready',
    description: 'The current report discovery returned columns',
  },
  errors: {
    id: 'app.RehireCheckStage.ReportRequests.errors',
    defaultMessage: 'Errors',
    description: 'The report request failed',
  },
  columns: {
    id: 'app.RehireCheckStage.ReportRequests.columns',
    defaultMessage:
      '{count, plural, one {# column found} other {# columns found}}',
    description: 'Number of columns returned by this report discovery',
  },
  noRows: {
    id: 'app.RehireCheckStage.ReportRequests.noRows',
    defaultMessage: 'No rows returned. Check the filter names.',
    description:
      'Discovery returned no rows; verify the configured filter names',
  },
});
